// global
require('./shared')
require('./shared_functions')
require('../fpa/vertical-accordion.js');
require('../site_scripts/mtc_vue_import')
require('../global/read-more')

// modules
require('../servicing/flyout-menu');
require('../servicing/offscreen-tabs');
require('../servicing/manufacturer-select');
require('../servicing/open-mobile-tabs-by-anchor-link');
require('../servicing/service-plan-booking-vue')
require('../servicing/book-service-mot')


// page specific styles
require('../../styles/entry/servicing.less')
